export const ItemPreview = {
  extends: [
    'Flex',
    'Link',
  ],
  flow: 'column',
  align: 'space-between flex-start',
  gap: 'C2',
  round: 'Z2',
  padding: 'A1 A1',
  whiteSpace: 'nowrap',
  href: (el) => {
    const key = el.getAppKey()
    return key ? '/account/' + key.split('.')[0] : null
  },
  transition: 'A defaultBezier',
  transitionProperty: 'background, color, border-color',
  borderWidth: '2px',
  borderStyle: 'solid',
  theme: 'common-card-outline-interactive',
  fontWeight: '400',
};